<template>
    <div class="relative inline-block text-left">
        <AppButton element="button" @click="open = !open" type="button">
            <svg class="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <path
                    fill-rule="evenodd"
                    d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z"
                    clip-rule="evenodd"
                ></path>
            </svg>
            {{ $t('messages.actions') }}
            <SlideOver :show="open" @close="open = false">
                <slot></slot>
            </SlideOver>
        </AppButton>
    </div>
</template>

<script>
import SlideOver from '@/components/SlideOver.vue';
import AppButton from '@/components/AppButton.vue';

export default {
    components: {
        AppButton,
        SlideOver,
    },
    emits: ['close'],

    data() {
        return {
            open: false,
        };
    },

    methods: {
        dismiss() {
            this.$emit('close');
        },
    },
};
</script>
